import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["value"]

import { ref, computed } from 'vue';
import { prefectures as prefectureList } from '@/js/data/area';
import genreList from '@/js/data/genre';
import IModal from '@/js/components/molecules/IModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'filter-sort',
  props: {
    initialPeriod: { default: undefined },
    initialGenres: { default: () => [] },
    initialPrefecture: { default: undefined },
    initialSort: { default: 'new' }
  },
  setup(__props: any) {

const props = __props;
const isFilterShow = ref(false);
const isSortShow = ref(false);
const period = ref(props.initialPeriod);
const genres = ref(props.initialGenres);
const prefecture = ref(props.initialPrefecture);
const sort = ref(props.initialSort);
const filterLabel = computed(() => {
  const conditionCount = (period.value === undefined ? 0 : 1) + genres.value.length + (prefecture.value === undefined ? 0 : 1);
  let label = '絞り込み';
  if (conditionCount > 0) {
    label += ` (${conditionCount})`;
  }
  return label;
});
const sortLabel = computed(() => (sort.value === 'ending' ? '終了日順' : '新着順'));
const queryString = computed(() => {
  const url = new URLSearchParams();

  if (period.value) {
    url.append('period', period.value);
  }
  if (genres.value.length > 0) {
    url.append('genre', genres.value.join(','));
  }
  if (prefecture.value) {
    url.append('prefecture', prefecture.value);
  }
  if (sort.value !== 'new') {
    url.append('sort', sort.value);
  }

  return url.toString();
});
const onClickOpenFilter = () => {
  isFilterShow.value = true;
  isSortShow.value = false;
};
const onClickResetFilter = () => {
  period.value = undefined;
  genres.value = [];
  prefecture.value = undefined;
};
const onClickSubmitFilter = () => {
  window.location.href = `?${queryString.value}`;
};
const onClickGenreItem = (slug: string) => {
  const index = genres.value.indexOf(slug);

  if (index === -1) {
    genres.value.push(slug);
  } else {
    genres.value.splice(index, 1);
  }
};
const onClickToggleSort = () => {
  isSortShow.value = !isSortShow.value;
  isFilterShow.value = false;
};
const onClickSortItem = (tmpSort: string) => {
  sort.value = tmpSort;
  isSortShow.value = false;
  window.location.href = `?${queryString.value}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.listMenu)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.filter)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.button),
          onClick: onClickOpenFilter
        }, [
          _createElementVNode("span", null, _toDisplayString(filterLabel.value), 1)
        ], 2)
      ], 2),
      _cache[12] || (_cache[12] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.sort)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.button, _ctx.$style.buttonDropdown, isSortShow.value ? _ctx.$style.active : '']),
          onClick: onClickToggleSort
        }, _toDisplayString(sortLabel.value), 3),
        _cache[11] || (_cache[11] = _createTextVNode()),
        _createElementVNode("div", null, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: _normalizeClass({ selected: sort.value === 'new' }),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickSortItem('new')))
            }, "新着順", 2),
            _cache[10] || (_cache[10] = _createTextVNode()),
            _createElementVNode("li", {
              class: _normalizeClass({ selected: sort.value === 'ending' }),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickSortItem('ending')))
            }, "終了日が近い順", 2)
          ])
        ])
      ], 2)
    ], 2),
    _cache[28] || (_cache[28] = _createTextVNode()),
    _createVNode(IModal, {
      modelValue: isFilterShow.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isFilterShow).value = $event)),
      width: "600px",
      "with-action-button": true,
      "text-cancel": "リセット",
      "text-ok": "検索結果を表示",
      "close-on-cancel": false,
      "close-on-ok": false,
      class: _normalizeClass(_ctx.$style.filterModal),
      onCancel: onClickResetFilter,
      onOk: onClickSubmitFilter
    }, {
      default: _withCtx(() => [
        _cache[20] || (_cache[20] = _createElementVNode("h4", null, "開催日", -1)),
        _cache[21] || (_cache[21] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.filterSelect, _ctx.$style.singleSelect])
        }, [
          _createElementVNode("a", {
            class: _normalizeClass([period.value === undefined ? _ctx.$style.selected : '']),
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (period.value = undefined), ["prevent"]))
          }, "全て", 2),
          _cache[13] || (_cache[13] = _createTextVNode()),
          _createElementVNode("a", {
            class: _normalizeClass([period.value === 'ongoing' ? _ctx.$style.selected : '']),
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (period.value = 'ongoing'), ["prevent"]))
          }, "開催中", 2),
          _cache[14] || (_cache[14] = _createTextVNode()),
          _createElementVNode("a", {
            class: _normalizeClass([period.value === 'this-week' ? _ctx.$style.selected : '']),
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (period.value = 'this-week'), ["prevent"]))
          }, "今週", 2),
          _cache[15] || (_cache[15] = _createTextVNode()),
          _createElementVNode("a", {
            class: _normalizeClass([period.value === 'this-weekend' ? _ctx.$style.selected : '']),
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (period.value = 'this-weekend'), ["prevent"]))
          }, "今週末", 2),
          _cache[16] || (_cache[16] = _createTextVNode()),
          _createElementVNode("a", {
            class: _normalizeClass([period.value === 'this-month' ? _ctx.$style.selected : '']),
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (period.value = 'this-month'), ["prevent"]))
          }, "今月", 2),
          _cache[17] || (_cache[17] = _createTextVNode()),
          _createElementVNode("a", {
            class: _normalizeClass([period.value === 'next-month' ? _ctx.$style.selected : '']),
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (period.value = 'next-month'), ["prevent"]))
          }, "来月以降", 2)
        ], 2),
        _cache[22] || (_cache[22] = _createTextVNode()),
        _cache[23] || (_cache[23] = _createElementVNode("h4", null, "ジャンル", -1)),
        _cache[24] || (_cache[24] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.filterSelect, _ctx.$style.multiSelect])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(genreList), (g) => {
            return (_openBlock(), _createElementBlock("a", {
              key: g.slug,
              class: _normalizeClass([genres.value.includes(g.slug) ? _ctx.$style.selected : '']),
              onClick: _withModifiers(($event: any) => (onClickGenreItem(g.slug)), ["prevent"])
            }, _toDisplayString(g.name), 11, _hoisted_1))
          }), 128))
        ], 2),
        _cache[25] || (_cache[25] = _createTextVNode()),
        _cache[26] || (_cache[26] = _createElementVNode("h4", null, "エリア", -1)),
        _cache[27] || (_cache[27] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.filterSelect)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.dropdownWrapper)
          }, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((prefecture).value = $event)),
              class: _normalizeClass({ selected: Boolean(prefecture.value) })
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("option", { value: undefined }, "都道府県を選ぶ", -1)),
              _cache[19] || (_cache[19] = _createTextVNode()),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(prefectureList), (p) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: p.slug,
                  value: p.slug
                }, _toDisplayString(p.name), 9, _hoisted_2))
              }), 128))
            ], 2), [
              [_vModelSelect, prefecture.value]
            ])
          ], 2)
        ], 2)
      ]),
      _: 1,
      __: [20,21,22,23,24,25,26,27]
    }, 8, ["modelValue", "class"])
  ], 64))
}
}

})